module.exports = __webpack_public_path__ + "img/map-bg.0e01b20e.png";